import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createCommunication,
  updateCommunication,
  getCommunication,
  deleteCommunication,
} from "../../../api/communication_api";

export const createCommunicationAction = createAsyncThunk(
  "communication/createCommunication",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createCommunication(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateCommunicationAction = createAsyncThunk(
  "communication/updateCommunication",
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateCommunication(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getCommunicationAction = createAsyncThunk(
  "communication/getCommunication",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getCommunication(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteCommunicationAction = createAsyncThunk(
  "communication/deleteCommunication",
  async (data, { rejectWithValue }) => {
    try {
      const response = await deleteCommunication(data);
      return { communicationID: data.communicationID, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
